import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {environment} from '../../environments/environment';
import {AccountInterfaceData, AccountInterfacePostData } from '../shared/models/account.model';

import {Observable} from 'rxjs';

@Injectable({providedIn: 'root'})
export class ForgotPasswordConfirmationService {

  url:string = `${environment['API_URL']}`

  constructor(private http: HttpClient,) {
  }

  forgotPasswordConfirmation(endpoint: string, email: string, code: string, password: string){
    let url = `${this.url}/${endpoint}`;
    return this.http.post(url, {
      email: email,
      code: code,
      password: password
    },{  headers: { 'Content-Type': 'application/json'},observe: 'response' })
  } //end forgotPasswordConfirm

} // end ForgotPasswordService
